import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import Marker from '../assets/images/marker.png';

const mapElement = document.getElementById('gmap');

if(mapElement){
  mapboxgl.accessToken = process.env.MIX_MAPBOX_API_KEY;

  const mapElement = document.querySelector('#gmap');
  var map = new mapboxgl.Map({
    container: mapElement.id,
    zoom: 12,
    center: [mapElement.dataset.latitude, mapElement.dataset.longitude],
    style: 'mapbox://styles/mapbox/streets-v10',
    interactive: true
  });

  map.on("load", function () {
    map.addControl(new mapboxgl.NavigationControl());
    map.loadImage(Marker, function(error, image) {
      if (error) throw error;
      map.addImage("custom-marker", image);
      map.addLayer({
        id: "markers",
        type: "symbol",
        source: {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features:[{"type":"Feature","geometry":{"type":"Point","coordinates":[mapElement.dataset.latitude, mapElement.dataset.longitude]}}]}
        },
        layout: {
          "icon-image": "custom-marker",
          "icon-size": 0.8
        }
      });
    });
  });
};
